import { OrdersAutoCancelExpirationTime } from '@tiendanube/common';

export const CHECKOUT_AVG_EXPIRATION_MINUTES: OrdersAutoCancelExpirationTime = 1440;
